<template>
  <router-view/>
</template>
<script>
  window.onload = function() {
    document.addEventListener('touchstart', function(event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    })
    document.addEventListener('gesturestart', function(event) {
      event.preventDefault()
    })
  }
</script>
<style>
  html {
    overflow-y: scroll;
  }

  :root {
    overflow-y: auto;
  }

  body {
    width: 100vw;
    overflow: hidden;
  }
</style>
